export const scrollToElement = (elementId: string) => {
  document
    .getElementById(elementId)
    ?.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'})
}
